/**
 * Convert buffer to base 64.
 *
 * @author Ihar Kazlouski
 * @param {string} Uint8Array buffer.
 * @return {string} base64 string.
 */
var arrayBufferToBase64 = function arrayBufferToBase64(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;

  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
};

export { arrayBufferToBase64 };